import React from 'react'
import Switch from 'components/Luxkit/Switch/Switch'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Group from 'components/utils/Group'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { toggleOfferComparisonEnabled } from 'actions/OfferComparisonActions'
import { selectOfferComparisonEnabled } from 'selectors/offerComparisonSelectors'
import { MAX_COMPARISON_SELECTIONS } from 'constants/offer'

interface Props {
  className?: string;
}

function CompareOffersToggle({ className }: Props) {
  const dispatch = useAppDispatch()
  const enabled = useAppSelector(selectOfferComparisonEnabled)

  const toggleEnabled = () => {
    dispatch(toggleOfferComparisonEnabled())
  }

  return (
    <Group className={className} direction="horizontal" horizontalAlign="space-between" verticalAlign="center" gap={8}>
      <Group direction="vertical">
        <BodyText variant="medium">Compare offers</BodyText>
        <BodyText variant="small" colour="neutral-three">View up to {MAX_COMPARISON_SELECTIONS} offers side by side.</BodyText>
      </Group>
      <Switch checked={enabled} onClick={toggleEnabled} />
    </Group>
  )
}

export default CompareOffersToggle
